export default __webpack_public_path__ + "static/media/TotalMadeVoids.08c75e2d.svg";